module.exports = __webpack_public_path__ + "img/Weapon_255.466f39fa.png";